var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"decorate"},[_vm._l((_vm.list),function(item,index){return [(item)?_c('li',{key:index,staticClass:"elements",style:([_vm.setBgStyle(item),_vm.setPosition(index)])}):_vm._e()]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }